import {standardChart} from './utilities';

export const figure19 = { 
      ...standardChart,

      chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        height: '400px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      colors: ['#afabab', '#00b050', '#ed7d31', '#ff0000'],
      tooltip: {
        pointFormat: '{series.val} : <b>{point.val}</b>'
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '<b>{point.val}</b>',
                distance: -50,
            }
        }
    },
    series: [{
        name: '',
        colorByPoint: true,
        data: [{
            name: 'Razas locales con una situación de crioconservación desconocida',
            y: 48,
            val: "3 697"
        }, {
            name: 'Razas locales con suficiente material genético almacenado para permitir su restauración',
            y: 3,
            val: "203"
        }, {
            name: 'Razas locales con insuficiente material genético almacenado',
            y: 6,
            val: "474"
        }, {
            name: 'Razas locales sin material genético almacenado',
            y: 43,
            val: "3 326",
        }]
    }]
}
